<template>
    <section class="section">
        <div class="card content notification" >
            <h1>Login</h1>
            <b-field title="Username">
                <b-input v-model="credentials.username" placeholder="Username" name="username"></b-input>
            </b-field>
            <b-field title="Password">
                <b-input v-model="credentials.password" placeholder="Password" name="password"
                         type="password"></b-input>
            </b-field>
            <button class="button is-primary" @click="login">Login</button>
        </div>
    </section>
</template>

<script>
    /* eslint-disable no-console */

    import BField from "buefy/src/components/field/Field";
    import BInput from "buefy/src/components/input/Input";

    export default {
        name: "Login",
        data() {
            return {
                credentials: {}
            }
        },
        components: {BInput, BField},
        methods: {
            login: function () {
                this.$store.dispatch('login', this.credentials)
                    .then(() => this.$router.push('/add'))
                    .catch(err => console.log(err))
            },
            autoLogin: function () {
                console.log("call autologin " + this.$store.getters.isLoggedIn)
                if(this.$store.getters.isLoggedIn){
                console.log("start autologin")
                    this.$store.dispatch('refresh')
                    .then(() => this.$router.push('/add'))
                    .catch(err => console.log(err))
                }
            }
        },
        mounted(){
            this.autoLogin()
        }
    }
</script>

<style scoped>

</style>
